import {
  TextField,
  InputLabel,
  IconButton,
  makeStyles,
  Theme,
} from "@material-ui/core";
import AddCircleOutline from "@material-ui/icons/AddCircleOutline";
import React, { ChangeEvent, useCallback, useEffect, useState } from "react";
import { ReviewManualDetailsDBResponse } from "@internal/plugin-ops-review-common";

const useStyles = makeStyles((_theme: Theme) => ({
  label: {
    marginBottom: "10px",
  },
}));

interface Props {
  data: ReviewManualDetailsDBResponse;
  setUpstreamData: React.Dispatch<React.SetStateAction<string[]>>;
}

export const WinsSection: React.FC<Props> = ({
  data,
  setUpstreamData,
}): JSX.Element => {
  const classes = useStyles();

  const [wins, setWins] = useState<string[]>([]);

  useEffect(() => {
    if (data) {
      setWins(data.wins);
      setUpstreamData(data.wins);
    }
  }, [data, setWins, setUpstreamData]);

  const handleWinsInputChange = useCallback(
    (event: ChangeEvent<{ value: string }>, id: number) => {
      const newWins = wins.slice();
      newWins[id] = event.target.value;
      setWins(newWins);
      setUpstreamData(newWins);
    },
    [wins, setWins, setUpstreamData]
  );

  const [winsSectionJsx, setWinsSectionJsx] = useState<JSX.Element[]>([
    <TextField
      id="wins-1"
      fullWidth
      onChange={(event: ChangeEvent<{ value: string }>) => {
        return handleWinsInputChange(event, 1);
      }}
      key="wins-1"
    />,
  ]);

  // Add a win
  const handleAddWinClick = () => {
    // .slice() is a hack to get this to work right
    const jsx = winsSectionJsx.slice();
    const id = winsSectionJsx.length;

    jsx.push(
      <TextField
        id={`wins-${id}`}
        fullWidth
        onChange={(event: ChangeEvent<{ value: string }>) =>
          handleWinsInputChange(event, id)
        }
        key={`wins-${id}`}
      />
    );
    setWinsSectionJsx(jsx);
  };

  useEffect(() => {
    const newJsx = wins.map((_w: string, idx: number) => {
      return (
        <TextField
          id={`wins-${idx}`}
          fullWidth
          onChange={(e: ChangeEvent<{ value: string }>) =>
            handleWinsInputChange(e, idx)
          }
          value={wins[idx]}
          key={`wins-${idx}`}
        />
      );
    });
    setWinsSectionJsx(newJsx);
  }, [wins, handleWinsInputChange, setWinsSectionJsx]);

  return (
    <>
      <InputLabel className={classes.label}>
        Add wins for the week{" "}
        <IconButton onClick={handleAddWinClick}>
          <AddCircleOutline />
        </IconButton>
      </InputLabel>
      {winsSectionJsx}
    </>
  );
};
